<settings-page-layout>
  <section class="maxx-settings__card">
    <pdq-tabs-group variant="underline" leftMargin="none" (onChange)="selectTab($event)">
      @for (tab of tabs; track tab.value) {
        <pdq-tab [value]="tab.value" [label]="tab.label" [active]="tab.value === activeTab"></pdq-tab>
      }
    </pdq-tabs-group>

    @if (activeTab === 'slack') {
      <pdq-maxx-slack-settings></pdq-maxx-slack-settings>
    } @else if (activeTab === 'brandKit') {
      <pdq-maxx-brand-kit-settings></pdq-maxx-brand-kit-settings>
    } @else if (activeTab === 'capabilities') {
      <pdq-maxx-capabilities-settings></pdq-maxx-capabilities-settings>
    } @else if (activeTab === 'monitoring') {
      <maxx-monitoring-settings></maxx-monitoring-settings>
    }
  </section>
</settings-page-layout>
